<template>
    <div >
            <el-card class="detail-card">
                <ul>
                    <li>
                        <p v-show="status=='服务台'&&canIEdit==true"> <el-button type="primary"  @click="appointFn('assessment')">接收资源评估工单</el-button></p>
                        <p v-show="status=='资源评估'&&canIEdit==true" ><el-button type="primary" @click="appointFn('assessment-approved')">评估通过</el-button></p>
                        <p v-show="status=='运维负责人审批'&&canIEdit==true"> <el-button type="primary"  @click="appointFn('it-head-approved')">运维审批通过</el-button></p>
                        <p v-show="status=='部门负责人审批'&&canIEdit==true"> <el-button type="primary"  @click="appointFn('dpt-head-approved')">部门审批通过</el-button></p>
                        <p v-show="status=='创建资源'&&canIEdit==true" ><el-button type="primary" @click="appointFn('complete')">创建完成</el-button></p>
                        <p v-show="status=='服务台'&&recoverEdit==true"><el-button type="primary" @click="recallEvent('withdraw')">撤回</el-button></p>
                        <p v-show="status !='处理完成'&&status!='拒绝'&&status!='创建'&&canIEdit==true"><el-button type="primary"  @click="appointFn('rebut')">驳回</el-button></p>
                        <p v-show="status=='创建'&&canIEdit==true"><el-button type="primary"  @click="deliver('submission')">提交</el-button></p>
                        <p  v-show="status!='服务台'&&status!='处理完成'&&status!='拒绝'&&canIEdit==true"> <el-button type="primary" @click="appointFn('transfer')" v-w-role="'ITSM-0252'">转交</el-button></p>
                            <!--拒绝-->
                        <p v-show="status!='处理完成'&&status!='拒绝'&&status!='创建'&&canIEdit==true"> <el-button type="primary" @click="appointFn('reject')" >拒绝</el-button></p>
                            <!--取消-->
<!--                        <p v-show="canCancel&&status!='变更完成'&&status!='取消'&&status!='拒绝'&&status!='变更失败'&&status!='创建'&&canIEdit==true"> <el-button type="primary"  @click="appointFn('cancel') ">取消</el-button></p>-->
                        <!--编辑-->
                        <p v-show="status!='处理完成'&&status!='拒绝'&&canIEdit==true"><el-button type="primary" @click="updateEvent">编辑</el-button></p>
                        <router-link :to="{ path: '/flowChart',query:{ serialNumber:serialNumber}}">
                            <el-button type="primary">流程跟踪</el-button>
                        </router-link>
                    </li>
                    <li>

                    </li>

                </ul>
                <el-row>
                    <el-col :span="6"><label>编号：</label>{{ detail.serial_number }}</el-col>
<!--                    <el-col :span="18"><label>标题:</label>{{ detail.title }}</el-col>-->
                </el-row>
                <el-row>
                    <el-col :span="6"><label>申请人：</label>{{ detail.applicant ? detail.applicant.name:'' }}</el-col>
                    <el-col :span="18"><label>创建时间：</label>{{ detail.create_time }}</el-col>
                </el-row>
            </el-card>
            <div class="tab-card">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane :label="item.name" :name="item.index" v-for="item in tabViews" :key="item.index">
                        <div v-loading="loading" v-if="loading" style="width:100%;height:300px;"></div>
                        <keep-alive v-if="!loading">
                            <component :is="currentView"
                                       :detail="detail"
                                       :status="status"
                                       :serialNumber="serialNumber"
                                       :callback="getDetail"
                                       :companyList="companyList"
                                       :eventList="eventList"
                                       :problemList="problemList"
                                       :changeList="changeList"
                                       :deployList="deployList"
                                       :hotFAQ="hotFAQ"
                            ></component>
                        </keep-alive>
                    </el-tab-pane>
                </el-tabs>
            </div>
    </div>
</template>

<script>
    import commonService from "../../services/common.service"
    import services from "./resourceApply.service";
    import detailForm from "./components/detailForm.vue";                     //表单明细
    import specifications  from "./components/specifications.vue";           //资源规格
    import HistoricRecords from "./components/detailHistoricRecords.vue";      // 历史记录
    import HistoricNews from "./components/detailHistoricNews.vue";            // 历史消息


    export default {

        data() {
            return {
                detail:{},
                attrData:[],
                companyList:[],
                eventList:[],
                problemList:[],
                changeList:[],
                deployList:[],
                status:"",   // 状态
                index:0,
                loading:true,
                activeName:"detailForm",
                hotFAQ:[],
                tabViews:[
                    { name:"表单明细",index:"detailForm"},
                    { name:"资源规格",index:"specifications"},
                    { name:"历史记录",index:"HistoricRecords"},
                    { name:"历史消息",index:"HistoricNews"},
                ],
                canCancel:false,
                canIEdit: false,
                recoverEdit:false,

            }

        },
        components:{
            detailForm,
            HistoricRecords,
            HistoricNews,
            specifications

        },
        computed:{
            currentView(){
                return this.tabViews[this.index].index;
            },
            query:function () {
                return this.$route.query
            },
            serialNumber:function () {
                return this.query.serialNumber
            },
            dictionary(){
                return this.$store.state.dictionary;
            },
            resourceStatus(){
                return this.dictionary.resource_application_status;
            },

            user(){

                // return window.localStorage.getItem('name')
                return window.localStorage.getItem('internalUserid') ? window.localStorage.getItem('internalUserid'): window.localStorage.getItem('internal_userid')
            },
            userCName(){

                return window.localStorage.getItem('name')
            },
            //登陆的用户角色类型:超管、服务台组、普通用户
            userRole(){
                return window.localStorage.getItem('userRole')
            },
        },
        watch:{
            '$route'(to,from){
                if (to.query.serialNumber != from.query.serialNumber){
                    this.sn = to.query.serialNumber
                    this.getDetail()
                }
            },

        },
        created() {
            if (this.$route.query){

                this.sn = this.$route.query.serialNumber
            }

            this.getDetail();

        },
        methods: {
            // 环境属
            getResourceTypeList(){
                services.getResourceTypeAttr({type_id:this.detail.resource_type}).then(res => {
                    this.$store.commit('setResourceTypeAttr',res)
                    // console.log('huoqu')
                    // console.log(this.$store.state.resourceTypeAttr)
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },
            getDetail(){
                if (this.userRole=='super'){
                    this.canIEdit=true
                    this.recoverEdit = true
                }else{
                    this.canIEdit=false
                    this.recoverEdit = false
                }
                services.getResourceApplyDetail({serial_number:this.serialNumber}).then(res => {
                    // console.log(res,'获取变更详情');
                    this.detail =  res;
                    this.getResourceTypeList()
                    if(JSON.stringify(res.wait_approve) !='{}'){
                        let data = {...res.wait_approve}
                        this.$store.commit('setWaitApprove', data)
                    }
                    // if(res.applicant.internalUserid&&res.applicant.internalUserid == this.user){
                    //     this.recoverEdit=true
                    //     this.canIEdit=true
                    // }
                    res.applicant.internalUserid&&res.applicant.internalUserid == this.user?this.recoverEdit=true:''
                    res.current_handler.internalUserid==this.user?this.canIEdit=true:''
                    this.status=this.getNameById(res.status,this.resourceStatus)
                    if (this.status=='服务台'&&this.userRole=='reception'){
                        this.canIEdit=true
                    }
                    if (this.status=='创建'&& res.applicant.internalUserid == this.user){
                        this.canIEdit=true
                    }
                    if (this.status=='服务台'&& res.applicant.internalUserid == this.user){
                        this.recoverEdit=true
                    }
                    // this.search();
                    // console.log(this.resourceStatus);
                    //判断取消按钮是否能出现
                    this.canICancel()
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(()=>{
                    this.loading=false
                })
            },
            //判断取消按钮是否能出现
            canICancel(){
                // console.log('lalla');
                let username =window.localStorage.getItem('name')
                let createUser=this.detail.applicant
                // let requester=this.detail.requester
                if (username==createUser){
                    this.canCancel=true
                }
            },

            search(){//默认查询
                services.getKnowledgeList({"Query":this.detail.title,"pageIndex":1,"pageSize":5}).then(res=>{
                    this.hotFAQ = res.KnowledgeTable;
                })
            },
            //指派
            appointFn(val){
                this.$router.push({
                    path: '/resourceApplyAppoint',
                    name: "resourceApplyAppoint",
                    query: {
                        type:val,
                        serialNumber:this.serialNumber,
                        callback:this.getDetail,
                        resource_type:this.detail.resource_alias,
                        status:this.status,
                        currentHandler:this.detail.current_handler
                    }
                })
            },
            // 撤回
            recallEvent(val){
                this.$confirm('您确定要撤回吗?', '撤回', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                    let params = {
                        serial_number:this.serialNumber,
                        handle: val
                    }
                    services.resourceApplyHandle(params).then(res => {
                        this.$message({
                            type: 'success',
                            message: '撤回成功!'
                        });
                        this.getDetail()
                    }).catch(err => {
                        this.isSubmit=false
                        this.$message.error(err.message);
                    })

                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消撤回'
                  });
                });
            },
            //编辑
            updateEvent(){
                this.$router.push({
                    path: '/resourceApplyAdd',
                    name: "resourceApplyAdd",
                    query: {
                        type:'edit',
                        serialNumber:this.serialNumber,
                        callback:this.getDetail
                    }
                })
            },
            deliver(text){
                this.openMessage('您确定要提交到服务台吗？', '确定', () => {
                    services.resourceApplyHandle({ handle:text,serial_number:this.serialNumber }).then(res => {
                        this.$message.success("提交成功");
                        this.getDetail();
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                });
            },
            //处理完成
            openMessage(message, confirmText, doit) {
                this.$confirm(message, '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: confirmText,
                    confirmButtonClass: 'confirmBtn'
                }).then(() => {
                    doit();
                })
            },
            handleClick(tab, event){
                this.index = tab.index;
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
    .zebra-item{
        span{
            padding-right: 10px;
        }
    }
    .el-button--mini{
        margin: 0 10px;
    }
</style>
